var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7346 33.3112C15.0477 32.9981 15.3608 32.5284 16.3001 32.5284C17.2395 32.5284 26.8677 32.5284 27.807 32.5284C28.668 32.5284 33.443 27.7535 34.0692 27.049C34.6172 26.4227 37.2786 22.5089 37.9831 20.7867C37.5134 20.1605 36.3393 19.6908 34.852 20.004C33.443 20.3171 32.6602 21.3347 31.7209 23.1351L28.2767 24.9355",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1964 27.8317C19.1964 27.8317 25.4586 27.8317 26.2414 27.8317C29.3725 27.8317 29.3725 23.9179 26.2414 23.9179C25.4586 23.9179 23.7365 23.9179 21.5447 23.9179C20.9185 23.9179 19.666 22.3523 18.6484 22.3523C18.1787 22.3523 15.8304 22.3523 14.7345 22.3523C13.6386 22.3523 12.3862 23.2134 11.6034 23.9179C10.4292 25.092 8.39401 26.9707 8.39401 26.9707",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93005 25.4355L3.00018 29.3654L11.6348 38L15.5647 34.0701L6.93005 25.4355Z",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9068 29.3972L8.47236 30.9628",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1551 20.0039V19.2211C30.1551 16.8727 26.5543 16.09 24.6756 16.09C22.797 16.09 19.1962 16.8727 19.1962 19.2211V20.0039",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6756 13.7417C22.9535 13.7417 21.5445 12.3327 21.5445 10.5323V9.90605C21.5445 8.18393 22.9535 6.69666 24.6756 6.69666C26.3978 6.69666 27.8068 8.10566 27.8068 9.90605V10.5323C27.8068 12.3327 26.3978 13.7417 24.6756 13.7417Z",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5779 19.6908C13.5603 17.9687 13.0123 15.9335 13.0123 13.7417C13.0123 7.24462 18.2569 2 24.754 2C31.2511 2 36.4957 7.24462 36.4957 13.7417C36.4957 14.9941 36.3391 16.1683 35.9477 17.2642",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCes);
export default __webpack_public_path__ + "static/media/dashboard_ces.26cf36226a2fc9deb8a5e5bad22c362a.svg";
export { ForwardRef as ReactComponent };